var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.342 11.626c-.01-1.803.806-3.162 2.456-4.164-.922-1.322-2.319-2.05-4.159-2.19-1.742-.137-3.649 1.016-4.347 1.016-.738 0-2.425-.968-3.752-.968C3.8 5.362.89 7.504.89 11.862c0 1.287.235 2.617.706 3.987.629 1.803 2.898 6.221 5.264 6.15 1.238-.029 2.113-.878 3.723-.878 1.563 0 2.372.878 3.752.878 2.388-.034 4.44-4.05 5.037-5.86-3.202-1.509-3.03-4.42-3.03-4.513Zm-2.779-8.064C14.903 1.97 14.782.52 14.743 0c-1.185.069-2.555.806-3.335 1.713-.86.973-1.364 2.177-1.256 3.533 1.28.098 2.449-.56 3.411-1.684Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.95bf1bc2.svg";
export { ForwardRef as ReactComponent };